import React, { useRef, useState } from 'react';
import { useClickOutside } from '../hooks/use-click-outside';
import Button from './Button';

interface Props {
  onClick: () => void;
  disabled?: boolean;
}

const DeleteButton: React.FC<Props> = ({
  onClick,
  disabled
}) => {
  const buttonRef = useRef(null)
  const [expanded, setExpanded] = useState(false);
  const btnClicked = () => {
    if (expanded) {
      onClick();
      setExpanded(false);
    } else {
      setExpanded(true);
    }
  }
  useClickOutside(buttonRef, () => setExpanded(false));
  return <div ref={buttonRef}>
    <Button color="danger" onClick={btnClicked} disabled={disabled}>{expanded ? 'Delete' : 'X'}</Button>
  </div>

}

export default DeleteButton;